/* SALT N SOUL — Theme JS
   Reveal on scroll, sticky header, AJAX cart, cart drawer, product variant sync.
*/
(function () {
  'use strict';

  // ---- Reveal on scroll ----
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -80px 0px' });
  document.querySelectorAll('.reveal').forEach((el) => io.observe(el));

  // ---- Sticky header ----
  const header = document.querySelector('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ---- Cart Drawer ----
  const drawer = document.getElementById('CartDrawer');
  const body   = document.getElementById('CartDrawer')?.querySelector('[data-cart-body]');
  const footer = document.getElementById('CartDrawer')?.querySelector('[data-cart-footer]');
  const totalEl = document.querySelector('[data-cart-total]');
  const countEls = document.querySelectorAll('[data-cart-count]');
  const money = (cents) => (cents / 100).toLocaleString(document.documentElement.lang || 'de-DE', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' });

  function openDrawer()  { drawer?.setAttribute('aria-hidden', 'false'); document.body.classList.add('cart-open'); refreshCart(); }
  function closeDrawer() { drawer?.setAttribute('aria-hidden', 'true');  document.body.classList.remove('cart-open'); }

  document.querySelectorAll('[data-cart-open]').forEach((el) => el.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); }));
  document.querySelectorAll('[data-cart-close]').forEach((el) => el.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  // Kuratierte Empfehlungen im Drawer (leerer & gefüllter Zustand)
  async function loadDrawerRecs(productId, excludeHandles) {
    const slot = body?.querySelector('[data-cart-recs]');
    if (!slot) return;
    try {
      let products = [];
      if (productId) {
        const r = await fetch(`/recommendations/products.js?product_id=${productId}&limit=6`, { headers: { Accept: 'application/json' } });
        if (r.ok) products = (await r.json()).products || [];
      }
      if (!products.length) {
        const r = await fetch('/products.json?limit=8', { headers: { Accept: 'application/json' } });
        if (r.ok) {
          products = ((await r.json()).products || []).map((p) => ({
            title: p.title,
            url: '/products/' + p.handle,
            handle: p.handle,
            featured_image: p.images && p.images[0] ? p.images[0].src : null,
            price: p.variants && p.variants[0] ? Math.round(parseFloat(p.variants[0].price) * 100) : null,
          }));
        }
      }
      products = products.filter((p) => !(excludeHandles || []).includes(p.handle)).slice(0, 4);
      if (!products.length) { slot.remove(); return; }
      slot.innerHTML = `
        <p class="cart-drawer__recs-title">Vielleicht auch schön</p>
        <div class="cart-drawer__recs-grid">
          ${products.map((p) => `
            <a href="${p.url}" class="cart-drawer__rec">
              ${p.featured_image ? `<img src="${p.featured_image}" alt="${escapeHtml(p.title)}" loading="lazy">` : ''}
              <span class="cart-drawer__rec-title">${escapeHtml(p.title)}</span>
              ${p.price != null ? `<span class="cart-drawer__rec-price">${money(p.price)}</span>` : ''}
            </a>`).join('')}
        </div>`;
    } catch (err) { slot.remove(); }
  }

  function renderCart(cart) {
    if (!body) return;
    countEls.forEach((el) => (el.textContent = cart.item_count));
    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cart-drawer__empty">Noch ist hier Ebbe — dein Warenkorb ist leer.</p><div class="cart-drawer__recs" data-cart-recs></div>';
      footer?.setAttribute('hidden', '');
      loadDrawerRecs(null, []);
      return;
    }
    footer?.removeAttribute('hidden');
    body.innerHTML = cart.items.map((item) => `
      <div class="cart-drawer__line" data-line-key="${item.key}">
        ${item.image ? `<img src="${item.image}" alt="${escapeHtml(item.product_title)}">` : ''}
        <div class="cart-drawer__line-info">
          <div class="cart-drawer__line-title">${escapeHtml(item.product_title)}</div>
          <div class="cart-drawer__line-variant">${escapeHtml(item.variant_title || '')} · Menge ${item.quantity}</div>
          <div class="cart-drawer__line-price">${money(item.final_line_price)}</div>
          <a href="#" class="cart-drawer__line-remove" data-remove="${item.key}">Entfernen</a>
        </div>
      </div>
    `).join('') + '<div class="cart-drawer__recs" data-cart-recs></div>';
    if (totalEl) totalEl.textContent = money(cart.total_price);

    body.querySelectorAll('[data-remove]').forEach((a) => a.addEventListener('click', async (e) => {
      e.preventDefault();
      await changeLine(a.dataset.remove, 0);
    }));

    loadDrawerRecs(cart.items[0].product_id, cart.items.map((i) => i.handle));
  }

  async function refreshCart() {
    try {
      const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      renderCart(await r.json());
    } catch (err) { console.error('Cart fetch failed', err); }
  }

  async function changeLine(id, quantity) {
    try {
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id, quantity }),
      });
      renderCart(await r.json());
    } catch (err) { console.error('Cart change failed', err); }
  }

  // ---- AJAX add-to-cart forms ----
  document.querySelectorAll('form[data-ajax-cart]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        if (!res.ok) throw new Error('Add to cart failed: ' + res.status);
        await refreshCart();
        openDrawer();
      } catch (err) {
        console.error(err);
        alert('Konnte Artikel nicht hinzufügen. Bitte versuche es erneut.');
      } finally {
        if (btn) btn.disabled = false;
      }
    });
  });

  refreshCart();

  // ---- Product variant sync ----
  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    const form = select.closest('form');
    if (!form) return;
    const optionInputs = form.querySelectorAll('[data-option-input]');
    optionInputs.forEach((input) => input.addEventListener('change', () => {
      const chosen = [];
      form.querySelectorAll('[data-option-input]:checked').forEach((i) => chosen.push(i.value));
      const match = Array.from(select.options).find((o) => o.dataset.options === chosen.join('||'));
      if (match) select.value = match.value;
    }));
  });

  // ---- Product image thumbnails ----
  document.querySelectorAll('[data-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const hero = document.querySelector('.product-page__hero img');
      if (hero) hero.src = thumb.dataset.full;
      document.querySelectorAll('[data-thumb]').forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
})();

/* ===== Erweiterungen: Stepper, Varianten-Preis, Empfehlungen ===== */
(function () {
  'use strict';

  // Mengen-Stepper
  document.querySelectorAll('[data-qty]').forEach((qty) => {
    const input = qty.querySelector('input');
    if (!input) return;
    const min = parseInt(input.min || '1', 10);
    qty.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      input.value = Math.max(min, (parseInt(input.value, 10) || min) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    qty.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      input.value = (parseInt(input.value, 10) || 0) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // Preis & Verfügbarkeit bei Variantenwechsel aktualisieren
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const select = form.querySelector('[data-variant-select]');
    const page = form.closest('.product-page') || document;
    const currentEl = page.querySelector('[data-current-price]');
    const compareEl = page.querySelector('[data-compare-price]');
    const addBtn = form.querySelector('[data-add-button]');
    const addLabel = form.querySelector('[data-add-label]');
    if (!select) return;

    const sync = () => {
      const chosen = [];
      form.querySelectorAll('[data-option-input]:checked').forEach((i) => chosen.push(i.value));
      const match = Array.from(select.options).find((o) => o.dataset.options === chosen.join('||'));
      if (!match) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Nicht verfügbar';
        return;
      }
      select.value = match.value;
      if (currentEl) currentEl.textContent = match.dataset.price || currentEl.textContent;
      if (compareEl) {
        if (match.dataset.compare) { compareEl.textContent = match.dataset.compare; compareEl.hidden = false; }
        else { compareEl.textContent = ''; compareEl.hidden = true; }
      }
      const available = match.dataset.available === 'true' && !match.disabled;
      if (addBtn) addBtn.disabled = !available;
      if (addLabel) addLabel.textContent = available ? 'In den Warenkorb' : 'Ausverkauft';
    };

    form.querySelectorAll('[data-option-input]').forEach((input) => input.addEventListener('change', sync));
  });

  // "Passt dazu" — Produktempfehlungen nachladen (Section Rendering API)
  document.querySelectorAll('[data-related]').forEach(async (el) => {
    if (!el.hasAttribute('hidden')) return; // wurde bereits serverseitig gerendert
    const url = el.dataset.url;
    if (!url) return;
    try {
      const res = await fetch(url);
      if (!res.ok) return;
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-related]');
      if (fresh && fresh.querySelector('.product-card')) {
        el.innerHTML = fresh.innerHTML;
        el.removeAttribute('hidden');
      }
    } catch (err) { /* Empfehlungen sind optional */ }
  });
})();

/* DAY-CYCLE START */
/* ===== Day Journey: Scroll-getriebener Tagesverlauf (Sunrise → Night) ===== */
(function () {
  'use strict';
  const section = document.querySelector('[data-day-cycle]');
  if (!section) return;

  const gradientEl = section.querySelector('[data-sky-gradient]');
  const sunEl = section.querySelector('[data-sky-sun]');
  const starsEl = section.querySelector('[data-sky-stars]');
  const waves = section.querySelectorAll('[data-sky-wave]');
  if (!gradientEl || !sunEl || !starsEl) return;

  // 70 Sterne, obere 70% des Himmels
  const frag = document.createDocumentFragment();
  for (let i = 0; i < 70; i++) {
    const s = document.createElement('span');
    s.style.left = (Math.random() * 100).toFixed(2) + '%';
    s.style.top = (Math.random() * 70).toFixed(2) + '%';
    const sc = (0.6 + Math.random() * 1.2).toFixed(2);
    s.style.transform = 'scale(' + sc + ')';
    s.style.opacity = (0.5 + Math.random() * 0.5).toFixed(2);
    frag.appendChild(s);
  }
  starsEl.appendChild(frag);

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Keyframes: p, [sky, mid, sea], [sunCore, sunGlow]
  const hex = (h) => [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)];
  const STOPS = [
    { p: 0.00, sky: hex('#FBEFDD'), mid: hex('#F3E5D8'), sea: hex('#BFD9D6'), core: hex('#FFE9C7'), glow: hex('#FFD9A0') },
    { p: 0.35, sky: hex('#DCEFF5'), mid: hex('#8FCBE0'), sea: hex('#2E7A99'), core: hex('#FFFFFF'), glow: hex('#FFF6D8') },
    { p: 0.65, sky: hex('#F7D9B8'), mid: hex('#E39A6E'), sea: hex('#8B4A42'), core: hex('#FFC98A'), glow: hex('#FF9E5E') },
    { p: 1.00, sky: hex('#16262A'), mid: hex('#1E3B3F'), sea: hex('#0E1F22'), core: hex('#EAF2F2'), glow: hex('#B9CCCB') },
  ];

  const lerp = (a, b, t) => a + (b - a) * t;
  const mix = (c1, c2, t) => [
    Math.round(lerp(c1[0], c2[0], t)),
    Math.round(lerp(c1[1], c2[1], t)),
    Math.round(lerp(c1[2], c2[2], t)),
  ];
  const rgb = (c, a) => (a === undefined ? 'rgb(' + c.join(',') + ')' : 'rgba(' + c.join(',') + ',' + a + ')');

  function sample(p) {
    let a = STOPS[0], b = STOPS[STOPS.length - 1];
    for (let i = 0; i < STOPS.length - 1; i++) {
      if (p >= STOPS[i].p && p <= STOPS[i + 1].p) { a = STOPS[i]; b = STOPS[i + 1]; break; }
    }
    const t = b.p === a.p ? 0 : (p - a.p) / (b.p - a.p);
    return {
      sky: mix(a.sky, b.sky, t), mid: mix(a.mid, b.mid, t), sea: mix(a.sea, b.sea, t),
      core: mix(a.core, b.core, t), glow: mix(a.glow, b.glow, t),
    };
  }

  function paint(p) {
    const c = sample(p);
    gradientEl.style.background = 'linear-gradient(180deg, ' + rgb(c.sky) + ' 0%, ' + rgb(c.mid) + ' 55%, ' + rgb(c.sea) + ' 100%)';

    // Sonnenbogen: steigt, kulminiert mittags, sinkt
    const left = 10 + p * 80;
    const top = 78 - Math.sin(p * Math.PI) * 62;
    sunEl.style.left = left.toFixed(2) + '%';
    sunEl.style.top = top.toFixed(2) + '%';
    sunEl.style.setProperty('--sun-core', rgb(c.core));
    sunEl.style.setProperty('--sun-glow', rgb(c.glow, 0.9));
    sunEl.style.setProperty('--sun-halo', rgb(c.glow, 0.55));
    // Ausblenden zwischen 0.82 und 0.92 (Nachteinbruch)
    const sunOpacity = p <= 0.82 ? 1 : p >= 0.92 ? 0 : 1 - (p - 0.82) / 0.10;
    sunEl.style.opacity = sunOpacity.toFixed(3);

    // Sterne: 0.78 → 0.93 einblenden
    const starOpacity = p <= 0.78 ? 0 : p >= 0.93 ? 1 : (p - 0.78) / 0.15;
    starsEl.style.opacity = starOpacity.toFixed(3);

    // Parallax-Wellen (unterschiedliche Geschwindigkeiten = Tiefe)
    waves.forEach((w) => {
      const f = parseFloat(w.dataset.skyWave || '0');
      w.style.transform = 'translateY(' + (-(p * 1000 * f)).toFixed(1) + 'px)';
    });
  }

  if (reduced) { paint(0); return; }

  let progress = 0, painted = -1, ticking = true;

  function readProgress() {
    const rect = section.getBoundingClientRect();
    const vh = window.innerHeight;
    const total = rect.height - vh;
    if (total <= 0) { progress = 0; return; }
    progress = Math.min(1, Math.max(0, -rect.top / total));
  }

  function loop() {
    readProgress();
    if (Math.abs(progress - painted) > 0.0005) {
      paint(progress);
      painted = progress;
    }
    if (ticking) requestAnimationFrame(loop);
  }

  // Loop nur laufen lassen, wenn die Section sichtbar ist (Akku/Mobile)
  const vis = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting && !ticking) { ticking = true; requestAnimationFrame(loop); }
      else if (!e.isIntersecting) { ticking = false; }
    });
  });
  vis.observe(section);
  requestAnimationFrame(loop);
})();
/* DAY-CYCLE END */

/* ===== Produktseite v2: Varianten-Engine mit Kombinations-Check ===== */
(function () {
  'use strict';
  document.querySelectorAll('[data-product-page]').forEach((page) => {
    const form = page.querySelector('[data-product-form]');
    const jsonEl = page.querySelector('[data-product-json]');
    if (!form || !jsonEl) return;
    let variants = [];
    try { variants = JSON.parse(jsonEl.textContent).variants; } catch (e) { return; }

    const idInput = form.querySelector('[data-variant-id]');
    const statusEl = form.querySelector('[data-variant-status]');
    const addBtn = form.querySelector('[data-add-button]');
    const addLabel = form.querySelector('[data-add-label]');
    const currentEl = page.querySelector('[data-current-price]');
    const compareEl = page.querySelector('[data-compare-price]');
    const inputs = Array.from(form.querySelectorAll('[data-option-input]'));
    const optionCount = inputs.reduce((m, i) => Math.max(m, parseInt(i.dataset.index, 10) + 1), 0);

    // Farb-Swatches einfärben
    const COLORS = {
      // SALT N SOUL Farbwelt — abgestimmt auf die verfügbaren Shirt-Töne
      'deep tide': '#1C1C1A',        // Black
      'salt': '#ECE8E1',             // Bone
      'terracotta shore': '#B4612F', // Clay
      'wet stone': '#2E3031',        // Graphite Black
      'driftwood grey': '#A9AAA6',   // Heather Grey
      'seagrass': '#9A9A5C',         // Light Olive
      'deep ocean': '#0E2A33',       // Midnight Navy
      'wet sand': '#8A7C6E',         // Shitake
      'coastal fog': '#9DB4CC',      // Stonewash Denim
      'dune': '#D9B38C',             // Tan
      'sea foam': '#FDFDFB',         // White
      // Original-Herstellernamen als Fallback, falls du sie so im Shop pflegst
      'black': '#1C1C1A', 'bone': '#ECE8E1', 'clay': '#B4612F', 'graphite black': '#2E3031',
      'heather grey': '#A9AAA6', 'light olive': '#9A9A5C', 'midnight navy': '#0E2A33',
      'shitake': '#8A7C6E', 'stonewash denim': '#9DB4CC', 'tan': '#D9B38C', 'white': '#FDFDFB',
    };
    page.querySelectorAll('.swatch__dot').forEach((dot) => {
      // Hat Shopify die Farbe/das Bild schon geliefert? Dann nur den Rand für helle Töne setzen.
      if (dot.hasAttribute('data-has-swatch')) {
        if (dot.style.backgroundImage) { dot.textContent = ''; dot.style.backgroundSize = 'cover'; dot.style.backgroundPosition = 'center'; return; }
        const m = (dot.style.backgroundColor || '').match(/\d+/g);
        if (m && m.length >= 3) {
          const lum = m[0] * .299 + m[1] * .587 + m[2] * .114;
          if (lum > 220) dot.style.borderColor = 'rgba(0,60,58,.35)';
        }
        return;
      }
      // Fallback: Farbe aus der Theme-Tabelle (nur falls im Admin nichts gepflegt ist)
      const c = COLORS[dot.dataset.colorName];
      if (c) {
        dot.style.background = c;
        dot.textContent = '';
        const lum = parseInt(c.slice(1, 3), 16) * .299 + parseInt(c.slice(3, 5), 16) * .587 + parseInt(c.slice(5, 7), 16) * .114;
        dot.style.borderColor = lum > 220 ? 'rgba(0,60,58,.35)' : 'transparent';
      }
    });

    const selected = () => {
      const vals = new Array(optionCount).fill(null);
      inputs.forEach((i) => { if (i.checked) vals[parseInt(i.dataset.index, 10)] = i.value; });
      return vals;
    };
    const matches = (variant, vals) => vals.every((v, idx) => v === null || variant.options[idx] === v);

    function refreshAvailability(vals) {
      inputs.forEach((input) => {
        const idx = parseInt(input.dataset.index, 10);
        const test = vals.slice();
        test[idx] = input.value;
        const exists = variants.some((v) => matches(v, test));
        const buyable = variants.some((v) => matches(v, test) && v.available);
        const wrap = input.closest('.pill, .swatch');
        wrap?.classList.toggle('is-soldout', exists && !buyable);
        wrap?.classList.toggle('is-missing', !exists);
      });
    }

    function sync() {
      const vals = selected();
      // Ausgewählte Werte neben dem Label anzeigen
      form.querySelectorAll('[data-option-index]').forEach((row) => {
        const idx = parseInt(row.dataset.optionIndex, 10);
        const label = row.querySelector('[data-selected-value]');
        if (label) label.textContent = vals[idx] || '—';
      });
      refreshAvailability(vals);

      if (vals.some((v) => v === null) && optionCount > 0) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Kombination wählen';
        if (statusEl) statusEl.textContent = 'Bitte Kombination wählen';
        return;
      }
      const variant = variants.find((v) => matches(v, vals)) || (optionCount === 0 ? variants[0] : null);
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Nicht verfügbar';
        if (statusEl) statusEl.textContent = 'Diese Kombination gibt es leider nicht';
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (currentEl) currentEl.textContent = variant.price;
      if (compareEl) {
        if (variant.compare) { compareEl.textContent = variant.compare; compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }
      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
      if (statusEl) statusEl.textContent = variant.available ? 'Auf Lager' : 'Diese Kombination ist ausverkauft';
    }

    inputs.forEach((i) => i.addEventListener('change', sync));
    sync();

    // Größenberater-Panel auf der Produktseite
    page.querySelectorAll('[data-sf-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const panel = btn.closest('.product-page__option')?.querySelector('[data-sf-panel]');
        if (panel) panel.hidden = !panel.hidden;
      });
    });
  });
})();

/* ===== Größenberater (Seite & Produkt-Panel) ===== */
(function () {
  'use strict';
  const RANGES = [
    { size: 'XS', min: 82, max: 90 },
    { size: 'S', min: 90, max: 98 },
    { size: 'M', min: 98, max: 106 },
    { size: 'L', min: 106, max: 114 },
    { size: 'XL', min: 114, max: 122 },
    { size: 'XXL', min: 122, max: 130 },
    { size: '3XL', min: 130, max: 140 },
  ];

  document.querySelectorAll('[data-size-finder]').forEach((box) => {
    const chestIn = box.querySelector('[data-sf-chest]');
    const heightIn = box.querySelector('[data-sf-height]');
    const result = box.querySelector('[data-sf-result]');
    const sizeOut = box.querySelector('[data-sf-size]');
    const sizeBtnOut = box.querySelector('[data-sf-size-btn]');
    const noteOut = box.querySelector('[data-sf-note]');
    const applyBtn = box.querySelector('[data-sf-apply]');
    const unitLabels = box.querySelectorAll('[data-sf-unit-label]');

    const unit = () => box.querySelector('[data-sf-unit]:checked')?.value || 'cm';
    const fitShift = () => parseInt(box.querySelector('[data-sf-fit]:checked')?.value || '0', 10);

    function calc() {
      unitLabels.forEach((l) => (l.textContent = unit()));
      let chest = parseFloat(chestIn?.value);
      if (!chest || chest <= 0) { if (result) result.hidden = true; highlight(null); return; }
      if (unit() === 'in') chest *= 2.54;

      let idx = RANGES.findIndex((r) => chest >= r.min && chest < r.max);
      if (idx === -1) idx = chest < RANGES[0].min ? 0 : RANGES.length - 1;
      idx = Math.min(RANGES.length - 1, Math.max(0, idx + fitShift()));
      const rec = RANGES[idx];

      let note = '';
      const height = parseFloat(heightIn?.value) * (unit() === 'in' ? 2.54 : 1);
      if (height && height >= 188 && idx < RANGES.length - 1) note = '— bei deiner Körpergröße darf es auch ' + RANGES[idx + 1].size + ' sein.';
      if (fitShift() < 0) note = '— eng geschnitten sitzt sie nah am Körper.';
      if (fitShift() > 0) note = '— eine Nummer größer für den entspannten Look.';

      if (sizeOut) sizeOut.textContent = rec.size;
      if (sizeBtnOut) sizeBtnOut.textContent = rec.size;
      if (noteOut) noteOut.textContent = note;
      if (result) result.hidden = false;
      highlight(rec.size);
      if (applyBtn) applyBtn.dataset.size = rec.size;
    }

    function highlight(size) {
      box.querySelectorAll('[data-sf-row]').forEach((tr) => tr.classList.toggle('is-recommended', tr.dataset.sfRow === size));
    }

    box.querySelectorAll('input').forEach((i) => {
      i.addEventListener('input', calc);
      i.addEventListener('change', calc);
    });

    // Empfohlene Größe direkt im Varianten-Selector übernehmen
    applyBtn?.addEventListener('click', () => {
      const size = applyBtn.dataset.size;
      if (!size) return;
      const form = box.closest('form');
      const target = Array.from(form?.querySelectorAll('[data-option-input]') || [])
        .find((i) => i.value.toUpperCase() === size.toUpperCase());
      if (target) {
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
        box.closest('[data-sf-panel]')?.setAttribute('hidden', '');
      }
    });
  });
})();

/* ===== Karussell-Pfeile ===== */
(function () {
  'use strict';
  document.querySelectorAll('[data-carousel]').forEach((track) => {
    const scope = track.closest('section') || document;
    const step = () => Math.max(240, track.clientWidth * 0.6);
    scope.querySelector('[data-carousel-prev]')?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    scope.querySelector('[data-carousel-next]')?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  });
})();
